module.exports = __webpack_public_path__ + "img/budetector-box.e1b1a16c.jpg";